import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { Section } from "../section";
import { Images } from "./images";
import { ThumbnailImage } from "./thumbnailImage";

export interface AssignmentImagesProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentImages = ({ campaign }: AssignmentImagesProps) => {
    const { t } = useTranslation(["common"]);

    const [isCollapsed, { toggle: toggleCollapse }] = useDisclosure(false);

    return (
        <Section
            title={t("campaign_images")}
            isCollapsed={isCollapsed}
            onClick={toggleCollapse}
        >
            <ThumbnailImage
                campaign={campaign}
            />
            <Box mt="xl">
                <Images
                    campaign={campaign}
                />
            </Box>
        </Section>
    );
};
